import {SpacingType, BreakpointType, validSpacingValues} from '@nib-components/theme';
import PropTypes from 'prop-types';
export const validOrderedListTypeValues = ['decimal', 'lower-alpha', 'none'] as const;
export type OrderedListType = (typeof validOrderedListTypeValues)[number];

export const validUnorderedListTypeValues = ['disc', 'circle', 'none'] as const;
export type UnorderedListType = (typeof validUnorderedListTypeValues)[number];

export const validListPositionValues = ['inside', 'outside'] as const;
export type ListPositionType = (typeof validListPositionValues)[number];

export type Nullable<T> = T | null;

type PartialRecord<K extends keyof never, T> = {
  [P in K]?: T;
};

export type ResponsiveProp<T> = PartialRecord<BreakpointType, T>;
export type ResponsiveOrStaticProp<T> = T | ResponsiveProp<T>;
export type ResponsiveSpaceProp = ResponsiveOrStaticProp<Nullable<SpacingType>>;

export const isValidSpacing = (value: number): number | boolean => value || value === 0;

export interface ListProps {
  children: React.ReactNode;
  space?: ResponsiveSpaceProp;
  inset?: ResponsiveSpaceProp;
  start?: number;
  reversed?: boolean;
  position?: ListPositionType;
  indent?: ResponsiveSpaceProp;
}

export const validComponentValues = ['p', 'em', 'strong', 'div', 'span', 'li'] as const;
export const validAlignValues = ['left', 'center', 'right'] as const;
export const validWeightValues = ['bold', 'normal'] as const;

const spacePropType = PropTypes.oneOf(validSpacingValues);

export const spacingPropTypeMap = PropTypes.oneOfType([
  spacePropType,
  PropTypes.shape({
    xs: spacePropType,
    sm: spacePropType,
    md: spacePropType,
    lg: spacePropType,
    xl: spacePropType,
    xxl: spacePropType,
    xxxl: spacePropType
  })
]);
